import BaseModelAPI from '../BaseModelAPI';

export default class WorkOrderProcessDetail extends BaseModelAPI {
	static entity = 'workorderprocessdetail';
	static entityName = 'workorderprocessdetail';

	constructor() {

		/*APP_MODEL_DEFINITION*/
		this.id = '';
		this.workOrderProcessId = '';
		this.workOrderProcess = {};
		this.partId = '';
		this.part = {};
		this.partName = '';
		this.partClassification = '';
		this.standarPackagingQty = '';
		this.billOfProcessId = '';
		this.billOfProcess = {};
		this.nextProcess = '';
		this.machineId = '';
		this.listMachine = '';
		this.machine = {};
		this.sph = '';
		this.qtyPlan = 0;
		this.hourPlan = 0;
		this.customer = '';
		this.remark = '';
		this.documentStatusId = '';
		this.documentStatus = {};
		this.lotNo = '';
		this.isReference = false;
		this.isPrintLabel = false;
		this.isFromUpload = false;
		this.isSavedToBackend = true;
		this.uploadValidationMessage = '';
		this.uploadValidationStatus = '';
		this.documentStatus = '';
		/*END_APP_MODEL_DEFINITION*/
	}

	static async printPdfCustom(this_, ids) {
		//const accessToken = this.useAuth ? await this_.$auth.getTokenSilently() : "";

		//let ids = _this.$store.state.dataIds;
		return this_.$http.post(`${this.entityName}/printpdfcustom/`, ids)
			.then(async function (response) {
				if (response.data) {
					return response.data;
				}
				return null;
			})
			.catch(function (error) {
				this_.$store.dispatch('addErrorMessageGlobal', error);
				throw error;
			});
	}

	static async printPCC(this_, id) {
		//const accessToken = this.useAuth ? await this_.$auth.getTokenSilently() : "";

		//let ids = _this.$store.state.dataIds;
		return this_.$http.post(`${this.entityName}/printpcc/` + id)
			.then(async function (response) {
				if (response.data) {
					return response.data;
				}
				return null;
			})
			.catch(function (error) {
				this_.$store.dispatch('addErrorMessageGlobal', error);
				throw error;
			});
	}

	static async printPCCAdditional(this_, id) {
		//const accessToken = this.useAuth ? await this_.$auth.getTokenSilently() : "";

		//let ids = _this.$store.state.dataIds;
		return this_.$http.post(`${this.entityName}/printpccadditional/` + id)
			.then(async function (response) {
				if (response.data) {
					return response.data;
				}
				return null;
			})
			.catch(function (error) {
				this_.$store.dispatch('addErrorMessageGlobal', error);
				throw error;
			});
	}

	static async printPCCPending(this_, id) {
		//const accessToken = this.useAuth ? await this_.$auth.getTokenSilently() : "";

		//let ids = _this.$store.state.dataIds;
		return this_.$http.post(`${this.entityName}/printpccpending/` + id)
			.then(async function (response) {
				if (response.data) {
					return response.data;
				}
				return null;
			})
			.catch(function (error) {
				this_.$store.dispatch('addErrorMessageGlobal', error);
				throw error;
			});
	}

	static async printPCCNg(this_, id) {
		//const accessToken = this.useAuth ? await this_.$auth.getTokenSilently() : "";

		//let ids = _this.$store.state.dataIds;
		return this_.$http.post(`${this.entityName}/printpccng/` + id)
			.then(async function (response) {
				if (response.data) {
					return response.data;
				}
				return null;
			})
			.catch(function (error) {
				this_.$store.dispatch('addErrorMessageGlobal', error);
				throw error;
			});
	}

	static async getListVw(this_, filter, sorting, pageIndex, pageSize, persistBy) {
		let filterArray = Array();
		if (filter != null && filter != undefined) {
			// console.log(filter);
			filterArray = this.getFilter(filter);
		}
		if (sorting != null && sorting != undefined) {
			Object.entries(sorting).map(([key, value]) => {
				if (key != '') {
					filterArray.push("sorting[" + key + "]=" + (value ? "1" : "0"));     // draftFromUpload & draftMode
				}
			});

		}
		if (pageIndex != null) {
			filterArray.push("pageIndex=" + pageIndex);
		}
		if (pageSize != null) {
			filterArray.push("pageSize=" + pageSize);
		}
		let params = "";
		if (filterArray.length > 0) {
			params = "?" + filterArray.join("&");
		}

		//DEBUG

		return this_.$http.get(`${this.entityName}/vwworkorderprocessdetail` + params)
			.then(response => {
				if (response != null) {
					return response.data;
				}
				return response;
			})
			.catch(function (error) {
				this_.$store.dispatch('addErrorMessageGlobal', error);
				throw error;
			});
	}

}